function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { incrementTweetView } from '@edusense/edusense-content-client';
import { getNavigatePath } from '../utils';
var useViewTracker = function(tweetId) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_minVisibleTime = options.minVisibleTime, minVisibleTime = _options_minVisibleTime === void 0 ? 2000 : _options_minVisibleTime, onEnterViewport = options.onEnterViewport;
    var elementRef = useRef(null);
    var timerRef = useRef(null);
    useEffect(function() {
        if (typeof window === 'undefined' || !window.IntersectionObserver) {
            return;
        }
        var handleVisibility = function(entries) {
            var _entries = _sliced_to_array(entries, 1), entry = _entries[0];
            if (!entry) return;
            if (entry.isIntersecting) {
                onEnterViewport === null || onEnterViewport === void 0 ? void 0 : onEnterViewport();
                if (timerRef.current === null) {
                    timerRef.current = window.setTimeout(/*#__PURE__*/ _async_to_generator(function() {
                        var error;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        3,
                                        4
                                    ]);
                                    return [
                                        4,
                                        incrementTweetView({
                                            id: tweetId
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    error = _state.sent();
                                    console.warn('[SocialPost] 조회수 증가 실패:', error);
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    timerRef.current = null;
                                    return [
                                        7
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }), minVisibleTime);
                }
            } else if (timerRef.current !== null) {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
        var observer = new IntersectionObserver(handleVisibility, {
            threshold: 0.5,
            rootMargin: '0px'
        });
        var node = elementRef.current;
        if (node) {
            observer.observe(node);
        }
        return function() {
            if (timerRef.current !== null) {
                window.clearTimeout(timerRef.current);
            }
            observer.disconnect();
        };
    }, [
        minVisibleTime,
        onEnterViewport,
        tweetId
    ]);
    return {
        ref: elementRef
    };
};
/**
 * SocialPost 컴포넌트의 이벤트 및 네비게이션 처리를 관리하는 훅
 */ export var useSocialPostEvents = function(id) {
    var isDetailView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, dataSource = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'default', path = arguments.length > 3 ? arguments[3] : void 0, onClick = arguments.length > 4 ? arguments[4] : void 0, disableViewTracking = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    // DOM 참조
    var postRef = useRef(null);
    var _useState = _sliced_to_array(useState(null), 2), threadTargetId = _useState[0], setThreadTargetId = _useState[1];
    // 조회수 추적 훅 사용 (조건부)
    var _ref = disableViewTracking ? {
        ref: useRef(null)
    } : useViewTracker(id, {
        minVisibleTime: 2000,
        onEnterViewport: function() {
            console.debug("트윗 ".concat(id, " 화면에 표시됨"));
        }
    }), viewTrackerRef = _ref.ref;
    // 스레드 라인 이벤트 처리
    useEffect(function() {
        // 스레드 라인 등록 이벤트 리스너
        var handleThreadLineRegistered = function(e) {
            var event = e;
            if (!event.detail || !postRef.current) return;
            // 현재 포스트 내의 아바타 컨테이너 찾기
            var avatarContainer = postRef.current.querySelector('[data-avatar-container]');
            if (avatarContainer) {
                // 위치 정보 계산
                var position = avatarContainer.getBoundingClientRect();
                // 스레드 라인 업데이트 이벤트 발생
                window.dispatchEvent(new CustomEvent('thread-line-update', {
                    detail: {
                        targetId: event.detail.id,
                        position: position
                    }
                }));
            }
        };
        // 이벤트 리스너 등록
        window.addEventListener('thread-line-registered', handleThreadLineRegistered);
        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return function() {
            window.removeEventListener('thread-line-registered', handleThreadLineRegistered);
        };
    }, []);
    // 안전한 navigate 사용
    var navigate;
    try {
        navigate = useNavigate();
    } catch (error) {
        navigate = function(path) {
            console.log("라우팅 컨텍스트 없음, 이동할 수 없습니다: ".concat(path));
        };
    }
    // 게시물 클릭 핸들러
    var handlePostClick = function() {
        if (dataSource === 'quoted' || isDetailView) {
            return;
        }
        // 상위 컴포넌트에서 제공한 경로 사용, 없으면 기본 post 경로 사용
        var navigatePath = getNavigatePath(path, id);
        navigate(navigatePath);
    };
    // 외부에서 전달된 onClick이 있으면 사용, 없으면 기본 핸들러 사용
    var clickHandler = onClick || handlePostClick;
    // 컴팩트 모드에서의 클릭 핸들러
    var handleCompactClick = function(e) {
        e.stopPropagation();
        if (onClick) onClick();
    };
    return {
        postRef: postRef,
        viewTrackerRef: viewTrackerRef,
        clickHandler: clickHandler,
        handleCompactClick: handleCompactClick
    };
};
